import { createSlice } from "@reduxjs/toolkit";

export const earnPointSlice = createSlice({
  name: "earn-point",
  initialState: {
    isPostLoading: false,

    data: [],

    message: "",
  },
  reducers: {
    onPostEarnPointSubmit: (state) => { 
      return {
        ...state,
        isPostLoading: true,
        postData: [],
        message: "",
      };
      
    },

    onPostEarnPointSuccess: (state, { payload }) => { 
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        isPostLoading: false,

        postData: data,
        message,
        status_code
      };
    },

    onPostEarnPointError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        postData:data,
        message,
        status_code,
        isPostLoading: false,

      };
    },
    onPostEarnPointReset: (state) => {
      return {
        ...state,
        isPostLoading: false,
        postData: [],
        message: "",
        status_code:null,
      };
      
    },
  },
});
export const { onPostEarnPointSubmit,onPostEarnPointSuccess,onPostEarnPointError,onPostEarnPointReset } =
earnPointSlice.actions;

export default earnPointSlice.reducer;
